import { getStorefrontOrigin } from '@/features/cms/preview/sfOrigin';

/**
 * QA-561/562 — 쇼핑몰 아티스트 페이지 짧은 주소. 스토어프론트가 `/artists/{slug}`(영문 활동명)를 UUID 와 함께 받는다
 * (storefront `features/artists/lib/artistSlug.ts`, 운영 4몰 200 확인). 슬러그 규칙은 FE 와 같다:
 * 소문자 + 영숫자 외 연속 글자는 하이픈, 양끝 하이픈 제거. 영문·숫자가 없는 이름은 슬러그가 없어 UUID 주소를 쓴다.
 */
export const artistSlug = (stageName: string | null | undefined): string =>
  (stageName ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const ARTIST_LINK_MALLS = [
  { mall: 'ko-KR', label: '한국몰', prefix: '' },
  { mall: 'en-US', label: '영문몰', prefix: '/us' },
  { mall: 'ja-JP', label: '일문몰', prefix: '/jp' },
  { mall: 'zh-CN', label: '중문몰', prefix: '/cn' },
] as const;

export type ArtistLinkMall = (typeof ARTIST_LINK_MALLS)[number]['mall'];

/** 몰별 아티스트 페이지 주소 — 슬러그가 있으면 짧은 주소, 없으면 UUID. */
export const buildStorefrontArtistUrl = (
  artist: { artistId: string; stageName: string | null | undefined },
  mall: ArtistLinkMall = 'ko-KR',
): string => {
  const prefix = ARTIST_LINK_MALLS.find((m) => m.mall === mall)?.prefix ?? '';
  const handle = artistSlug(artist.stageName) || artist.artistId;
  return `${getStorefrontOrigin()}${prefix}/artists/${encodeURIComponent(handle)}`;
};
